export default "__VITE_ASSET__6765b1f6__"